import React, {useEffect, useState} from "react"
import { Text, TextProps } from "../../vanilla"
import { DateUtils } from '../../utils/date-utils'
import { useBasketStore, useGlobalStore } from "../../store/hooks/useStore"
import { ShopperCustomers } from "commerce-api"

interface DeliveryTimeProps {
  startHour?: string
  endHour?: string
  textProps?: Omit<TextProps<'span'>, 'children'>
  showDate?: boolean
  showTime?: boolean
  dayText?: string
  order?: ShopperCustomers.Order
  dateFormat?: string
  windowStartTime?: string
  windowEndTime?: string
}

export const DeliveryTimeAndDate = ({
  startHour,
  endHour,
  textProps,
  showDate = false,
  showTime = true,
  dayText,
  order,
  dateFormat = 'do MMMM',
  windowStartTime,
  windowEndTime
}: DeliveryTimeProps) => {
  const { basket } = useBasketStore()
  const { isCustomSitePreferenceSet, getCustomSitePreferenceById, customSitePreferences } = useGlobalStore()
  let is12HourClock;


  (async function () {
      if (!isCustomSitePreferenceSet('showSlotTimesIn12HourClock')) {
        await getCustomSitePreferenceById('showSlotTimesIn12HourClock')
      }
      is12HourClock = (customSitePreferences['showSlotTimesIn12HourClock'] as boolean || false)
    }
  )()
  
  let deliveryTime, deliveryDate

  // Determine which c_windowStartTime to use
  const _windowStartTime = order?.c_windowStartTime || basket?.c_windowStartTime || windowStartTime || ''
  const _windowEndTime = order?.c_windowEndTime || basket?.c_windowEndTime || windowEndTime || ''

  if (startHour && endHour) {
    // Use the props for the time range if provided, and convert if the 12H pref is true
    deliveryTime = is12HourClock ? `${DateUtils.convertTo12h(startHour)} - ${DateUtils.convertTo12h(endHour)}` : `${startHour} - ${endHour}`
  } 
  if (showDate && _windowStartTime && _windowEndTime) {
    // Use the order/basket/window props and formatDeliveryDate, passing in the 12H pref
    const [, dateOnly] = DateUtils.formatDeliveryDate(_windowStartTime, _windowEndTime, dateFormat, is12HourClock) || []
    deliveryDate = dateOnly
  }
  if (!startHour && !endHour && _windowStartTime && _windowEndTime && showTime) {
  // Fallback for when there is no time range provided, but a time is needed
  [deliveryTime, deliveryDate] = DateUtils.formatDeliveryDate(_windowStartTime, _windowEndTime, dateFormat, is12HourClock) || []
}

  return (
    <>
      <Text data-test-selector="delivery-date-time-section" {...textProps} >
          {/* Only show the comma when deliveryTime is also present */}
          {deliveryTime && <>{deliveryTime}</>}{showDate && deliveryTime && deliveryDate && <>, </> }
          {/* If there is extra day text, show it on a new line */}
          {dayText && <><br />{dayText} </>}
          {/* Show the delivery date if present and required */}
          {showDate && deliveryDate && <>{deliveryDate}</>}
        </Text>
    </>
  )
}